export const areaList = [
  {
    title: '舞台仪式区',
    key: 'stage'
  },
  {
    title: '迎宾签到区',
    key: 'check'
  },
  {
    title: '婚礼细节',
    key: 'detail'
  }
]
